
import BarChart from '@/components/charts/BarChart.vue';
import { defineComponent } from 'vue';
export default defineComponent({
  components: {
    BarChart
  }
})
